export default "__VITE_ASSET__b5a1b99e__$_?component__"